import { ACCESS_LEVEL_VIEW } from "../../../../constants";

const isComingSoon = ({ loyaltyBenefit }) =>
  loyaltyBenefit?.customerAccess === ACCESS_LEVEL_VIEW;

export default isComingSoon;
